// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortsPlayer_shortsContainer__l72Ey {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    background-color: #0f0f0f;
    scroll-snap-type: y mandatory;
    -ms-overflow-style: none;  /* Hide scrollbar for IE and Edge */
    scrollbar-width: none;     /* Hide scrollbar for Firefox */
    position: relative;
  }
  
  .shortsPlayer_shortsContainer__l72Ey::-webkit-scrollbar {
    display: none;  /* Hide scrollbar for Chrome, Safari and Opera */
  }
  
  .shortsPlayer_shortsItem__fFev6 {
    position: relative;
    width: 100%;
    height: 100vh;
    scroll-snap-align: start;
    scroll-snap-stop: always;
    display: flex;
    justify-content: center;
  }
  
  .shortsPlayer_videoContainer__KbDLv {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: black;
    cursor: pointer;
  }
  
  .shortsPlayer_shortsVideo__P34e8 {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: black;
    max-width: 450px; /* Limit width for better mobile experience */
    margin: 0 auto;
  }
  
  .shortsPlayer_playOverlay__qsOlk {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 2;
  }
  
  .shortsPlayer_playIcon__QEjGL {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 0 20px 40px;
    border-color: transparent transparent transparent white;
    opacity: 0.8;
  }
  
  .shortsPlayer_shortsInfo__lacTq {
    position: absolute;
    bottom: 50px;
    left: 0;
    width: 100%;
    color: white;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    z-index: 1;
  }
  
  .shortsPlayer_shortsDetails__dnjb6 {
    flex: 1 1;
    max-width: 70%;
  }
  
  .shortsPlayer_shortsTitle__ZWImt {
    margin: 0 0 5px 0;
    font-size: 18px;
    font-weight: 600;
  }
  
  .shortsPlayer_shortsCreator__L8DOd {
    margin: 0 0 5px 0;
    font-size: 14px;
    opacity: 0.9;
  }
  
  .shortsPlayer_shortsDescription__7uV4N {
    margin: 0;
    font-size: 13px;
    opacity: 0.8;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  .shortsPlayer_shortsActions__d1uqo {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .shortsPlayer_actionButton__uQG7X {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 5px;
    transition: transform 0.2s, color 0.2s;
  }
  
  .shortsPlayer_actionButton__uQG7X:hover {
    color: #ff0000;
    transform: scale(1.1);
  }
  
  .shortsPlayer_actionButton__uQG7X:active {
    transform: scale(0.95);
  }
  
  .shortsPlayer_actionCount__RcEEl, .shortsPlayer_actionText__v7kcO {
    margin-top: 4px;
    font-size: 12px;
  }
  
  /* Fix for Lucide icons */
  .shortsPlayer_actionButton__uQG7X svg {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  
  .shortsPlayer_shortsLoading__qHBRW, .shortsPlayer_shortsError__PqnmL {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    background-color: #0f0f0f;
  }
  
  /* Media Queries for Responsive Design */
  @media (min-width: 768px) {
    .shortsPlayer_shortsContainer__l72Ey {
      max-width: 450px;
      margin: 0 auto;
      border-radius: 8px;
      overflow: hidden;
      height: 80vh;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }
    
    .shortsPlayer_shortsItem__fFev6 {
      height: 80vh;
      margin-top: 5rem;
    }
  }
  
  @media (max-width: 480px) {
    .shortsPlayer_shortsDetails__dnjb6 {
      max-width: 65%;
    }
    
    .shortsPlayer_shortsTitle__ZWImt {
      font-size: 16px;
    }
    
    .shortsPlayer_shortsDescription__7uV4N {
      -webkit-line-clamp: 1;
      font-size: 12px;
    }
    
    .shortsPlayer_actionButton__uQG7X svg {
      width: 20px;
      height: 20px;
    }
    
    .shortsPlayer_actionCount__RcEEl, .shortsPlayer_actionText__v7kcO {
      font-size: 10px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/shorts/shortsPlayer.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,wBAAwB,GAAG,mCAAmC;IAC9D,qBAAqB,MAAM,+BAA+B;IAC1D,kBAAkB;EACpB;;EAEA;IACE,aAAa,GAAG,gDAAgD;EAClE;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,wBAAwB;IACxB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB,EAAE,6CAA6C;IAC/D,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,uDAAuD;IACvD,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAS;IACT,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA,wCAAwC;EACxC;IACE;MACE,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,YAAY;MACZ,uCAAuC;IACzC;;IAEA;MACE,YAAY;MACZ,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,qBAAqB;MACrB,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".shortsContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100vh;\n    overflow-y: scroll;\n    background-color: #0f0f0f;\n    scroll-snap-type: y mandatory;\n    -ms-overflow-style: none;  /* Hide scrollbar for IE and Edge */\n    scrollbar-width: none;     /* Hide scrollbar for Firefox */\n    position: relative;\n  }\n  \n  .shortsContainer::-webkit-scrollbar {\n    display: none;  /* Hide scrollbar for Chrome, Safari and Opera */\n  }\n  \n  .shortsItem {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    scroll-snap-align: start;\n    scroll-snap-stop: always;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .videoContainer {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: black;\n    cursor: pointer;\n  }\n  \n  .shortsVideo {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    background-color: black;\n    max-width: 450px; /* Limit width for better mobile experience */\n    margin: 0 auto;\n  }\n  \n  .playOverlay {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.4);\n    z-index: 2;\n  }\n  \n  .playIcon {\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 20px 0 20px 40px;\n    border-color: transparent transparent transparent white;\n    opacity: 0.8;\n  }\n  \n  .shortsInfo {\n    position: absolute;\n    bottom: 50px;\n    left: 0;\n    width: 100%;\n    color: white;\n    display: flex;\n    justify-content: space-around;\n    align-items: flex-end;\n    z-index: 1;\n  }\n  \n  .shortsDetails {\n    flex: 1;\n    max-width: 70%;\n  }\n  \n  .shortsTitle {\n    margin: 0 0 5px 0;\n    font-size: 18px;\n    font-weight: 600;\n  }\n  \n  .shortsCreator {\n    margin: 0 0 5px 0;\n    font-size: 14px;\n    opacity: 0.9;\n  }\n  \n  .shortsDescription {\n    margin: 0;\n    font-size: 13px;\n    opacity: 0.8;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n  \n  .shortsActions {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n  }\n  \n  .actionButton {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n    padding: 5px;\n    transition: transform 0.2s, color 0.2s;\n  }\n  \n  .actionButton:hover {\n    color: #ff0000;\n    transform: scale(1.1);\n  }\n  \n  .actionButton:active {\n    transform: scale(0.95);\n  }\n  \n  .actionCount, .actionText {\n    margin-top: 4px;\n    font-size: 12px;\n  }\n  \n  /* Fix for Lucide icons */\n  .actionButton svg {\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }\n  \n  .shortsLoading, .shortsError {\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-size: 18px;\n    background-color: #0f0f0f;\n  }\n  \n  /* Media Queries for Responsive Design */\n  @media (min-width: 768px) {\n    .shortsContainer {\n      max-width: 450px;\n      margin: 0 auto;\n      border-radius: 8px;\n      overflow: hidden;\n      height: 80vh;\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n    }\n    \n    .shortsItem {\n      height: 80vh;\n      margin-top: 5rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .shortsDetails {\n      max-width: 65%;\n    }\n    \n    .shortsTitle {\n      font-size: 16px;\n    }\n    \n    .shortsDescription {\n      -webkit-line-clamp: 1;\n      font-size: 12px;\n    }\n    \n    .actionButton svg {\n      width: 20px;\n      height: 20px;\n    }\n    \n    .actionCount, .actionText {\n      font-size: 10px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shortsContainer": `shortsPlayer_shortsContainer__l72Ey`,
	"shortsItem": `shortsPlayer_shortsItem__fFev6`,
	"videoContainer": `shortsPlayer_videoContainer__KbDLv`,
	"shortsVideo": `shortsPlayer_shortsVideo__P34e8`,
	"playOverlay": `shortsPlayer_playOverlay__qsOlk`,
	"playIcon": `shortsPlayer_playIcon__QEjGL`,
	"shortsInfo": `shortsPlayer_shortsInfo__lacTq`,
	"shortsDetails": `shortsPlayer_shortsDetails__dnjb6`,
	"shortsTitle": `shortsPlayer_shortsTitle__ZWImt`,
	"shortsCreator": `shortsPlayer_shortsCreator__L8DOd`,
	"shortsDescription": `shortsPlayer_shortsDescription__7uV4N`,
	"shortsActions": `shortsPlayer_shortsActions__d1uqo`,
	"actionButton": `shortsPlayer_actionButton__uQG7X`,
	"actionCount": `shortsPlayer_actionCount__RcEEl`,
	"actionText": `shortsPlayer_actionText__v7kcO`,
	"shortsLoading": `shortsPlayer_shortsLoading__qHBRW`,
	"shortsError": `shortsPlayer_shortsError__PqnmL`
};
export default ___CSS_LOADER_EXPORT___;
